export default "__VITE_ASSET__b28b17ec__"